import React, {useMemo} from "react";
import ButtonComponent from "../../../components/buttonComponent";
import RefreshIcon from '@mui/icons-material/Refresh';

const OrdersPageHeader = (props) => {
    const {
        isInternal,
        supplierName,
        isExternalFactoryUser,
        handleTableRefresh,
    } = props;

    return (
        <div id="allorders-page-header-div" className="w-full flex !justify-between !flex-nowrap !ml-0 !mr-0">
            <div id="allorders-select-fwder-div" className="pt-2 items-center !flex-grow-0 !w-full">
            </div>
            <div className="!w-full pt-3">
                <p className="text-xs text-center">
                    <b id="allorders-title">Load Schedule</b>
                </p>
            </div>
            <div className="flex !w-full space-x-2  justify-end">
                <ButtonComponent
                    handleFunction={handleTableRefresh}
                    variant={null}
                    tooltip={"Refresh Data"}
                >
                    <RefreshIcon style={{ fontSize: '20px' }} />
                </ButtonComponent>
            </div>
        </div>
    );
};

export default OrdersPageHeader;
